import styled from 'styled-components';
import { ModalBackdrop, modalPanelSheet } from '../ModalPrimitives.styled';

export { ModalBackdrop };

export const ModalContainer = styled.div`
  ${modalPanelSheet}
  position: relative;
  width: 100%;
  max-width: 620px;
  max-height: min(90vh, 820px);
  overflow-y: auto;
  padding: 20px 24px 24px;

  @media (max-width: 767px) {
    align-self: flex-end;
    max-width: 100%;
    max-height: 88vh;
    border-radius: ${p =>
      `${p.theme.modal.radiusSheet} ${p.theme.modal.radiusSheet} 0 0`};
    padding: 16px 16px 24px;
  }
`;

export const CloseBtnWpar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
`;

export const ModalHeaderTitles = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CloseBtn = styled.button`
  width: 36px;
  height: 36px;
  background-color: ${p =>
    p.theme.ui.scheme === 'dark' ? '#1e293b' : '#f8fafc'};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  border-radius: 9999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  transition: 200ms ease;

  :hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-color: ${p => p.theme.colors.main.orangeMain};
  }
`;
export const ModalTitle = styled.p`
  font-family: 'Kulim Park';
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: ${p => p.theme.colors.main.orangeMain};
  margin: 0 0 4px;
`;
export const ModalSubtitle = styled.p`
  font-size: 13px;
  line-height: 1.4;
  color: ${p => p.theme.colors.text.gray};
  margin: 0;
`;
export const Divider = styled.div`
  height: 1px;
  background: ${p => p.theme.colors.main.grayLight};
  margin-bottom: 16px;

  @media (max-width: 767px) {
    margin-bottom: 12px;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 24px;
`;

export const CategoryContainer = styled.ul`
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
`;

export const CategoryBtn = styled.button`
  width: 64px;
  height: 64px;
  border: none;
  background-color: transparent;
  border-radius: 16px;

  cursor: pointer;
  :hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }
  :focus {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }
  :active {
    background-color: ${p => p.theme.colors.main.orangeLight};
    border-radius: 16px;
  }
`;

export const CategoryText = styled.p`
  color: ${p => p.theme.colors.text.text};
  font-family: 'Kulim Park';
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;
`;

export const DescriptionContainer = styled.div`
  margin-bottom: 16px;
`;

export const Text = styled.p`
  font-family: 'Kulim Park';
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 4px;
`;

export const DescriptionInput = styled.input`
  display: block;
  width: 100%;
  height: 40px;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 30px;
  border: none;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  color: ${p => p.theme.colors.text.text};
  text-indent: 12px;
  ::placeholder {
    font-family: 'Kulim Park';
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.04em;
    color: ${p => p.theme.colors.text.gray};
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border: 1px solid ${p => p.theme.colors.main.orangeLight};
  border-radius: 20px;
  background-color: transparent;
  font-family: 'Roboto';
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  color: ${p => p.theme.colors.main.orangeMain};
  margin-right: 8px;
  cursor: pointer;
  :hover {
    background-color: ${p => p.theme.colors.main.orangeLight};
  }
  :focus {
    background-color: ${p => p.theme.colors.main.orangeLight};
  }
  :active {
    background-color: ${p => p.theme.colors.main.orangeLight};
  }
`;
export const AmountInput = styled.input`
  width: 116px;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 20px;
  padding: 8px 16px;
  border: none;
  font-family: 'Kulim Park';
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  color: ${p => p.theme.colors.main.orangeMain};
  box-sizing: border-box;

  ::placeholder {
    color: ${p => p.theme.colors.text.gray};
  }
`;
export const AmountContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
`;
export const WarningMessage = styled.p`
  position: absolute;
  color: red;
  font-size: 8px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  margin-top: 4px;
`;

export const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border: 1px solid ${p => p.theme.colors.main.orangeLight};
  border-radius: 20px;
  background-color: transparent;

  margin-right: 8px;
`;
export const DateInput = styled.input`
  width: 112px;
  height: 40px;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 20px;
  border: none;
  text-indent: 12px;
  font-family: 'Kulim Park';
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  color: ${p => p.theme.colors.text.text};
  text-indent: 12px;
  ::placeholder {
    font-family: 'Kulim Park';
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 0.04em;
    color: ${p => p.theme.colors.text.gray};
  }
`;

export const CheckedText = styled.label`
  width: 120px;
  font-family: 'Kulim Park';
  font-size: 10px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  align-items: center;
  display: flex;
  cursor: pointer;
  ::before {
    content: ' ';
    width: 10px;
    height: 10px;
    border: 1px solid ${p => p.theme.colors.main.orangeMain};
    border-radius: 2px;
    margin-right: 12px;
    cursor: pointer;
  }
  input:checked + &::before {
    display: flex;
    content: '✔';
    justify-content: center;
    text-align: center;
    font-size: 8px;
    color: ${p => p.theme.colors.main.orangeMain};
  }
`;

export const InputCheckbox = styled.input`
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  overflow: hidden;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  margin: -1px;
`;
export const Label = styled.label`
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => p.theme.colors.text.text};
  margin-bottom: 4px;
`;